// Recipe data for Mirage Foods

export const recipes = [
  {
    id: 'instant-pastry-cream',
    title: 'Instant Pastry Cream',
    path: '/instant-pastry-cream',
    cardImage: '/images/recipes/instant-pastry-cream/hero.jpg',
    heroImage: '/images/recipes/instant-pastry-cream/hero.jpg',
    sideImage: '/images/recipes/instant-pastry-cream/side.jpg',
    servings: { value: 4, min: 4, max: 32, step: 4 },
    facts: {
      prepTime: '5-7 minutes',
      setTime: 'Instantly',
      amount: '4 x 5-oz/Serving'
    },
    ingredients: [
      { label: 'Instant Pastry Cream', quantity: '8-oz/227g' },
      { label: 'Water', quantity: '20-oz' }
    ],
    intro:
      'This instant pastry cream mix makes it possible to prepare the classic French filling in minutes with reduced fat/calorie. Prep time: 3-5 mins. Sets instantly after whipping.',
    directions: {
      title: 'Mirage Pastry Cream Preparation',
      steps: [
        'Place water in a mixing bowl and whisk in the Mirage Pastry Cream Mix, making certain all the powder is fully absorbed by the water.',
        'Using a hand mixer, Kitchen Aid, or other larger commercial mixer (depending on volume), mix at medium speed for 2 minutes, then high speed for 4 minutes longer, or until desired creamy texture is achieved.',
        'Once prepared, keep the pastry cream refrigerated and use within 3 days.',
        'Vanilla, hazelnut, or other flavors may be added to this mixture.',
        'If adding fruit puree, reduce water by 1 oz for every ounce of puree used. A small amount of water may be slowly added into the mix if necessary to achieve optimum creamy texture. For extra rich texture, replace half the water with milk.',
        'This pastry cream may be frozen and thawed for later use.'
      ]
    },
    variations: [
      { type: 'heading', text: 'Variations' },
      {
        type: 'subheading',
        level: 'h3',
        text: 'Mango, Banana or Other Fruit Cream Filling'
      },
      {
        type: 'ol',
        items: [
          'Banana, mango, or other fruit puree may be added with discretion. For each 10 oz of liquid in this recipe, use no more than 2-3 oz of puree or texture may be adversely affected.',
          'Blend the banana or mango puree with water first. Then add in the mix slowly to incorporate all powder into the water.',
          'Continue to mix at medium speed for 2 minutes, followed by high speed for 4 minutes longer.',
          'Spoon into tart or pie shell. Or, using a pastry bag, pipe into eclair, cannoli, or puff pastry.',
          'Uses: A classic French cream filling for tarts, cannoli, eclairs, puff pastry, or Boston cream pies.'
        ]
      }
    ]
  },
  {
    id: 'creme-brulee',
    title: 'Creme Brulee',
    path: '/creme-brulee',
    cardImage: '/images/recipes/creme-brulee/hero.jpg',
    heroImage: '/images/recipes/creme-brulee/hero.jpg',
    sideImage: '/images/recipes/creme-brulee/side.jpg',
    servings: { value: 4, min: 4, max: 32, step: 4 },
    facts: {
      prepTime: '5 minutes',
      setTime: '2 hours min',
      amount: '4-oz/Serving'
    },
    ingredients: [
      { label: 'Creme Brule Base', quantity: '2-oz/57g' },
      { label: 'Heavy Cream', quantity: '8-oz/900g' },
      { label: 'Milk', quantity: '8-oz/900g' }
    ],
    intro: null,
    directions: {
      title: 'Creme Brule Base Preparation',
      steps: [
        'Bring heavy cream and milk to a near boil (bubbles at outer rim of liquid).',
        'Using a whisk, briskly stir in the Creme Brule Base and continue to cook for one full minute - use a timer to avoid overcooking.',
        'Remove from heat and pour into ramekins. Allow to cool, then refrigerate to set. Caramelize with torch and granulated sugar after set.',
        'If using reduced-calorie recipe with half & half only, add 10% more base to achieve desired density/texture.',
        'Refrigerate for a minimum of 1 hour to set for best results. 2 hours if using half & half only.'
      ]
    },
    variations: [
      { type: 'heading', text: 'Variations' },
      { type: 'subheading', level: 'h2', text: 'Chocolate Creme Brulee' },
      { type: 'subheading', level: 'h3', text: 'Ingredients' },
      {
        type: 'ul',
        items: [
          '8 oz Half and Half',
          '8 oz Heavy Cream',
          '3.5 oz Mirage Creme Brulee Base',
          '100 g Milk Chocolate',
          '100 g Dark Chocolate',
          '6 g Vanilla Paste (optional)'
        ]
      },
      { type: 'subheading', level: 'h3', text: 'Preparation' },
      {
        type: 'ol',
        items: [
          'Whisk 4 oz (115 g) of milk into the Mirage Creme Brulee powder.',
          'Bring the remaining milk, heavy cream, chocolate, and vanilla paste to a boil.',
          'Add the Creme Brulee mixture to the hot heavy cream and bring to a boil again.',
          'Pour mixture into ramekins and allow to chill thoroughly.',
          'Brulee the desserts with sugar and a blow torch, then serve.',
          'Alternatively, add your favorite topping and serve.'
        ]
      },
      { type: 'subheading', level: 'h3', text: 'Topping Options' },
      {
        type: 'p',
        text:
          'Classic Topping: Granulated sugar caramelized with torch or baked in broiler 2-3 inches from flame. Alternative Toppings: Fresh fruit slices or puree, chocolate or caramel syrup, almonds or pecans.'
      }
    ]
  },
  {
    id: 'panna-cotta',
    title: 'Panna Cotta',
    path: '/panna-cotta',
    cardImage: '/images/recipes/panna-cotta/hero.png',
    heroImage: '/images/recipes/panna-cotta/hero.png',
    sideImage: '/images/recipes/panna-cotta/side.jpg',
    servings: { value: 4, min: 4, max: 32, step: 4 },
    facts: {
      prepTime: '5 minutes',
      setTime: '2 hours min',
      amount: '16oz/450g'
    },
    ingredients: [
      { label: 'Panna Cotta Base', quantity: '2.5-oz/71g' },
      { label: 'Milk', quantity: '9-oz/255' },
      { label: 'Heavy Cream', quantity: '11.5-oz/326' }
    ],
    intro:
      'This versatile panna cotta base makes it possible to prepare the classic Italian dessert in minutes with reduced fat/calorie variations possible. Prep time: 5 mins. Set time: 1-2 hours.',
    directions: {
      title: 'Panna Cotta Preparation',
      steps: [
        'Divide the heavy cream and milk in half. In a saucepan, bring half the combined liquid to a scalding boil.',
        'Using a whisk or mixer, briskly stir in the Panna Cotta Base into the remaining heavy cream and milk. This liquid should NOT be hot.',
        'Add this cold Panna Cotta and cream mixture into the boiling liquid and bring the entire batch to a second boil.',
        'Remove from heat and pour into shallow dessert cups or stemmed dessert cups. (Minimum recipe serves 5 x 4-oz cups)',
        'Refrigerate for a minimum of 1-2 hours to set for best results.'
      ]
    },
    variations: [
      { type: 'heading', text: 'Variations' },
      { type: 'subheading', level: 'h3', text: 'Chocolate Panna Cotta' },
      {
        type: 'ol',
        items: [
          'Adjust chocolate or cocoa powder to your desired depth using approximately 1-2 tbsp (4-8 g) per 2.5 oz of Panna Cotta Base.',
          'While heating half of the cream, stir in cocoa powder or melt chocolate chips into the liquid, stirring continuously until fully melted and smooth. (Use bitter or milk chocolate to achieve desired flavor/color.)',
          'Whisk in the Panna Cotta Cream mixture and bring to a boil again.',
          'Remove from heat and pour into dessert cups or ramekins.',
          'Top with chocolate shavings, caramel syrup, almonds, or pecans.'
        ]
      },
      { type: 'subheading', level: 'h3', text: 'Mango Panna Cotta' },
      {
        type: 'ol',
        items: [
          'Replace 2 oz of dairy with 2 oz mango puree for each 10 oz of liquid in this recipe.',
          'While heating, stir the mango puree into the liquid continuously until boiling.',
          'Whisk in the Panna Cotta Cream mixture and bring to a boil again.',
          'Remove from heat and pour into dessert cups or ramekins.',
          'After chilling and setting, layer with fresh mango slices.'
        ]
      },
      { type: 'subheading', level: 'h3', text: 'Matcha Panna Cotta' },
      {
        type: 'ol',
        items: [
          'For matcha green tea version, add approximately 1.25 mg matcha powder per 2.5 oz of Panna Cotta Base used. Adjust to desired color intensity.',
          'While heating the dairy, stir in the matcha powder continuously until boiling. Add small amounts to achieve desired intensity.',
          'Whisk in the cold Panna Cotta Cream mixture and bring to a boil again.',
          'Remove from heat and pour into dessert cups or ramekins.',
          'After chilling and setting, layer with fresh kiwi or lime gelatin.'
        ]
      },
      { type: 'divider' },
      {
        type: 'ul',
        items: [
          'Key ingredients are bold for easy scanning.',
          'Step numbers make it structured and readable.',
          'Variations are clearly separated with headings.'
        ]
      }
    ]
  },
  {
    id: 'miragelle-mousse',
    title: 'Miragelle Mousse',
    path: '/miragelle-mousse',
    cardImage: '/images/recipes/miragelle-mousse/hero.jpg',
    heroImage: '/images/recipes/miragelle-mousse/hero.jpg',
    sideImage: '/images/recipes/miragelle-mousse/side.jpg',
    servings: { value: 4, min: 4, max: 32, step: 4 },
    facts: {
      prepTime: '5 minutes',
      setTime: '1-2 hours min',
      amount: '4 x 4-oz'
    },
    ingredients: [
      { label: 'Miragelle Mousse Mix', quantity: '8-oz/227g' },
      { label: 'Water', quantity: '8-oz' },
      { label: 'Heavy Cream', quantity: '8-oz' }
    ],
    intro: null,
    directions: {
      title: 'Miragelle Mousse Preparation',
      steps: [
        'Place water in a mixing bowl and whisk in the Miragelle Mousse Mix, making sure all the powder is fully absorbed.',
        'Add in the cream. Using a hand mixer, Kitchen Aid, or other commercial mixer, mix at medium speed for 2 minutes, then high speed for 3 minutes or until desired creamy texture is achieved.',
        'Once prepared, pour into dessert cups and refrigerate to set for 1-2 hours.'
      ]
    },
    variations: [
      { type: 'heading', text: 'Variations' },
      {
        type: 'ol',
        items: [
          'Vanilla, coconut, or other flavors may be added. For fruit flavors, replace water with fruit juice or puree and prepare as in steps 1-3. Coconut water (without pulp) may be used instead of water. If using coconut milk or almond milk instead of water, reduce cream by 1 oz.',
          'For chocolate mousse, add 8 oz (220 g) water to 4.5 oz (130 g) Miragelle Mix and 12 oz (340 g) heavy cream. Whip. Add 12 oz (340 g) chocolate (64%) and whip well.'
        ]
      }
    ]
  }
];
